import { EIntervalType, } from "../entities/PartnerNRSummaryEntity";
import { currentYearMonthsArr, quartersArr, } from "@frameworks/salesjourney/components/Features/RevenueDashBoard/constant";
export var partnerNRSummaryDataMapper = function (data, req) {
    var result = {
        intervalData: [],
        tableData: [],
        graphData: [],
    };
    if (data && data.length > 0) {
        var intervals_1 = sortIntervals(Array.from(new Set(data.map(function (item) { return item.interval; }))), req.IntervalType);
        var products = Array.from(new Set(data.map(function (item) { return item.product; })));
        // This loop initialize the result object with required number of rows for products
        products.forEach(function (prod) {
            var tableDataObj = {
                upcId: 0,
                productInterval: "",
                product: prod,
                sbPassOut: 0,
                subProductList: [],
                intervalList: [],
            };
            result.tableData.push(tableDataObj);
        });
        // This loop initialize required number of columns
        intervals_1.forEach(function (interval) {
            var intervalListObj = {
                sbPassOut: 0,
                intervalName: interval,
                yearName: "",
            };
            var graphObj = {
                interval: interval,
                yearName: "",
                totalSbPassOut: 0,
                productList: [],
            };
            result.intervalData.push(intervalListObj);
            result.graphData.push(graphObj);
        });
        result.tableData = result.tableData.map(function (currentProduct) {
            var allProducts = data.filter(function (prod) { return prod.product === currentProduct.product; });
            // This loop initialize the subProduct array for each product
            allProducts.forEach(function (prod) {
                var existingSubProduct = currentProduct.subProductList.filter(function (subProd) { return subProd.subProduct === prod.subProduct; });
                if (!existingSubProduct.length) {
                    var subProduct = {
                        upcId: prod.upcId,
                        subProduct: prod.subProduct,
                        subProductInterval: prod.interval,
                        sbPassOut: prod.sbPassout,
                        intervalList: [],
                    };
                    currentProduct.subProductList.push(subProduct);
                }
            });
            intervals_1.forEach(function (currInterval) {
                var currentIntervalData = allProducts.filter(function (currProd) { return currProd.interval === currInterval; });
                if (currentIntervalData.length) {
                    currentIntervalData.forEach(function (data) {
                        var index = currentProduct.intervalList.findIndex(function (val) { return val.intervalName === data.interval; });
                        var subProductIndex = currentProduct.subProductList.findIndex(function (subProdVal) {
                            return subProdVal.subProduct === data.subProduct &&
                                subProdVal.subProductInterval === data.interval;
                        });
                        if (subProductIndex === -1) {
                            currentProduct.subProductList.forEach(function (item) {
                                item.intervalList.push({
                                    intervalName: data.interval,
                                    sbPassOut: data.sbPassout,
                                    yearName: data.yearName,
                                });
                            });
                        }
                        else {
                            currentProduct.subProductList[subProductIndex].intervalList.push({
                                intervalName: data.interval,
                                sbPassOut: data.sbPassout,
                                yearName: data.yearName,
                            });
                        }
                        if (index === -1) {
                            currentProduct.intervalList.push({
                                intervalName: data.interval,
                                sbPassOut: data.sbPassout,
                                yearName: data.yearName,
                            });
                            result.intervalData
                                .filter(function (item) { return item.intervalName === currInterval; })
                                .map(function (res) {
                                res.yearName = data.yearName;
                                res.sbPassOut += data.sbPassout;
                                return res;
                            });
                        }
                        else {
                            currentProduct.intervalList[index].sbPassOut += data.sbPassout;
                            result.intervalData
                                .filter(function (item) { return item.intervalName === currInterval; })
                                .map(function (res) {
                                res.yearName = data.yearName;
                                res.sbPassOut += data.sbPassout;
                                return res;
                            });
                        }
                    });
                }
                else {
                    currentProduct.intervalList.push({
                        intervalName: currInterval,
                        sbPassOut: 0,
                        yearName: "",
                    });
                    currentProduct.subProductList = currentProduct.subProductList.map(function (subProd) {
                        subProd.intervalList.push({
                            intervalName: currInterval,
                            sbPassOut: 0,
                            yearName: "",
                        });
                        return subProd;
                    });
                }
            });
            return currentProduct;
        });
        result.graphData = result.graphData.map(function (item) {
            var allProducts = data.filter(function (filteredData) { return filteredData.interval === item.interval; });
            var totalSbPassOut = 0;
            allProducts.forEach(function (prod) {
                totalSbPassOut += prod.sbPassout;
                var productIndex = item.productList.findIndex(function (val) { return val.productName === prod.product; });
                if (productIndex === -1) {
                    item.productList.push({
                        interval: prod.interval,
                        productName: prod.product,
                        totalAmount: prod.sbPassout,
                    });
                }
                else {
                    item.productList[productIndex].totalAmount += prod.sbPassout;
                }
            });
            item.totalSbPassOut = totalSbPassOut;
            return item;
        });
    }
    // if (data && data.length > 0) {
    //   let product: Array<string> = [];
    //   let intervals = Array.from(new Set(data.map((item) => item.interval)));
    //   intervals.map((interval) => {
    //     let graphIntervals: IPartnerNRGraphDataEntity = {
    //       interval: interval,
    //       totalSbPassOut: 0,
    //       productList: [],
    //       yearName: "",
    //     };
    //     result.graphData.push(graphIntervals);
    //   });
    //   data.map((item) => {
    //     if (!product.includes(item.product)) {
    //       product.push(item.product);
    //       let localInterval: Array<IIntervalList> = [];
    //       intervals.map((interval) => {
    //         let localObj: IIntervalList = {
    //           intervalName: interval,
    //           yearName: item.yearName,
    //           sbPassOut: 0,
    //         };
    //         localInterval.push(localObj);
    //         result.intervalData.push(localObj);
    //       });
    //       let productObj: IPartnerNRTableEntity = {
    //         upcId: item.upcId,
    //         productInterval: "",
    //         product: item.product,
    //         sbPassOut: 0,
    //         subProductList: [],
    //         intervalList: localInterval,
    //       };
    //       result.tableData.push(productObj);
    //     }
    //   });
    //   result.tableData = result.tableData.map((item) => {
    //     let localSubProdList: Array<ISubProductList> = [];
    //     let subProductName: Array<string> = [];
    //     data
    //       .filter((subItem) => subItem.product === item.product)
    //       .map((rec) => {
    //         if (!subProductName.includes(rec.subProduct)) {
    //           let localInterval: Array<IIntervalList> = [];
    //           intervals.map((interval, idx) => {
    //             let localObj: IIntervalList = {
    //               intervalName: interval,
    //               sbPassOut: 0,
    //               yearName: rec.yearName,
    //             };
    //             localInterval.push(localObj);
    //           });
    //           subProductName.push(rec.subProduct);
    //           let localObj: ISubProductList = {
    //             upcId: rec.upcId,
    //             subProduct: rec.subProduct,
    //             subProductInterval: rec.interval,
    //             sbPassOut: rec.sbPassout,
    //             intervalList: localInterval,
    //           };
    //           localSubProdList.push(localObj);
    //         }
    //       });
    //     item.subProductList = localSubProdList;
    //     return item;
    //   });
    //   result.tableData = result.tableData.map((item) => {
    //     item.subProductList.map((subProduct) => {
    //       subProduct.intervalList.map((interval, index) => {
    //         data
    //           .filter(
    //             (dt) =>
    //               dt.interval === interval.intervalName &&
    //               dt.product === item.product &&
    //               dt.subProduct === subProduct.subProduct
    //           )
    //           .map((newItem) => {
    //             interval.sbPassOut = newItem.sbPassout;
    //             item.intervalList[index].sbPassOut += newItem.sbPassout;
    //             return newItem;
    //           });
    //       });
    //       return subProduct;
    //     });
    //     return item;
    //   });
    //   result.graphData = result.graphData.map((item) => {
    //     let localProdList: IPartnerNRGraphProductEntity[] = [];
    //     product.map((prod) => {
    //       data
    //         .filter(
    //           (subItem) =>
    //             subItem.interval === item.interval && subItem.product === prod
    //         )
    //         .map((filteredData) => {
    //           item.yearName = filteredData.yearName;
    //           if (localProdList.length > 0) {
    //             if (
    //               localProdList.filter(
    //                 (it) => it.productName !== filteredData.product
    //               ).length > 0
    //             ) {
    //               let prodObj: IPartnerNRGraphProductEntity = {
    //                 productName: filteredData.product,
    //                 totalAmount: filteredData.sbPassout,
    //                 interval: filteredData.interval,
    //               };
    //               localProdList.push(prodObj);
    //             } else {
    //               localProdList[
    //                 localProdList.findIndex(
    //                   (prodName) => prodName.productName === filteredData.product
    //                 )
    //               ].totalAmount += filteredData.sbPassout;
    //             }
    //           } else {
    //             let prodObj: IPartnerNRGraphProductEntity = {
    //               productName: filteredData.product,
    //               totalAmount: filteredData.sbPassout,
    //               interval: filteredData.interval,
    //             };
    //             localProdList.push(prodObj);
    //           }
    //         });
    //     });
    //     item.productList = localProdList;
    //     localProdList.map((localProdData) => {
    //       item.totalSbPassOut += localProdData.totalAmount;
    //     });
    //     return item;
    //   });
    // }
    return result;
};
var sortFinancialYears = function (years) {
    years.sort(function (a, b) {
        if (a < b)
            return -1;
        if (a > b)
            return 1;
    });
    return years;
};
var sortIntervals = function (unsortedArr, intervalType) {
    var sortedArr = [];
    switch (intervalType) {
        case EIntervalType.Yearly:
            sortedArr = sortFinancialYears(unsortedArr);
            return sortedArr;
        case EIntervalType.Monthly:
            currentYearMonthsArr.forEach(function (item) {
                unsortedArr.forEach(function (val) {
                    if (val === null || val === void 0 ? void 0 : val.match(new RegExp("".concat(item)))) {
                        sortedArr.push(val);
                    }
                });
            });
            return sortedArr;
        case EIntervalType.Quarterly:
            quartersArr.forEach(function (item) {
                unsortedArr.forEach(function (val) {
                    if (val === item) {
                        sortedArr.push(val);
                    }
                });
            });
            return sortedArr;
        default:
            return sortedArr;
    }
};
